"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.storeTableConfigInLocalStorage = exports.shuffleDndItems = exports.shouldReallySetInitialWidth = exports.setColumnsInitialWidth = exports.rebuildColumnsDef = exports.isString = exports.isObject = exports.isFunction = exports.hydradeColumnsFromLocalStorage = exports.getTooltipPropsFromCallback = exports.getSelectionColumn = exports.getMaxHeaderCount = exports.flattenColumns = exports.findIndexByKey = exports.extractColumns = exports.buildHeaderRow = exports.CLASS_PREFIX = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sortable = require("@dnd-kit/sortable");

var _reactBaseTable = require("react-base-table");

var _BodyCell = _interopRequireDefault(require("./components/BodyCell"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context7, _context8; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty2(_context7 = ownKeys(Object(source), !0)).call(_context7, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty2(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var CLASS_PREFIX = "orion-data-grid";
/* istanbul ignore next */
// This function is being used in DnD feature so ignoring it. We don't test DnD in jestdom

exports.CLASS_PREFIX = CLASS_PREFIX;

var findIndexByKey = function findIndexByKey(items, key) {
  return (0, _findIndex["default"])(items).call(items, function (elem) {
    return elem.key === key;
  });
};

exports.findIndexByKey = findIndexByKey;

var makeCompatibleColumn = function makeCompatibleColumn(_ref, responsive) {
  var alignItems = _ref.alignItems,
      key = _ref.key,
      className = _ref.className,
      headerClassName = _ref.headerClassName,
      style = _ref.style,
      title = _ref.title,
      dataKey = _ref.dataKey,
      dataGetter = _ref.dataGetter,
      textAlign = _ref.textAlign,
      flexGrow = _ref.flexGrow,
      flexShrink = _ref.flexShrink,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      fixed = _ref.fixed,
      hidden = _ref.hidden,
      resizable = _ref.resizable,
      sortable = _ref.sortable,
      fixable = _ref.fixable,
      togglable = _ref.togglable,
      draggable = _ref.draggable,
      cellRenderer = _ref.cellRenderer,
      headerRenderer = _ref.headerRenderer,
      truncateText = _ref.truncateText,
      tooltip = _ref.tooltip,
      children = _ref.children,
      exportable = _ref.exportable,
      getCsvValue = _ref.getCsvValue,
      csvTitle = _ref.csvTitle,
      isLoading = _ref.isLoading,
      isError = _ref.isError;
  return {
    key: key,
    className: (0, _classnames["default"])(alignItems && "".concat(CLASS_PREFIX, "__row-cell--valign-").concat(alignItems), truncateText && "".concat(CLASS_PREFIX, "__row-cell--truncate-text"), className),
    headerClassName: (0, _classnames["default"])(resizable && "".concat(CLASS_PREFIX, "__header-cell--resizable"), headerClassName),
    style: style,
    title: title,
    dataKey: dataKey,
    dataGetter: dataGetter,
    align: textAlign,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    width:
    /* istanbul ignore next */
    responsive ? 0 : width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    frozen: fixed,
    hidden: hidden,
    resizable: resizable,
    sortable: isLoading || isError ? false : sortable,
    fixable: fixable,
    togglable: togglable,
    draggable: draggable,
    cellRenderer: cellRenderer ? function (_ref2) {
      var cellData = _ref2.cellData,
          _ = _ref2._,
          __ = _ref2.__,
          ___ = _ref2.___,
          rowData = _ref2.rowData,
          rowIndex = _ref2.rowIndex;
      return cellRenderer(cellData, dataKey, rowIndex, rowData);
    } : _BodyCell["default"],
    headerRenderer: headerRenderer,
    truncateText: truncateText,
    tooltip: tooltip,
    children: children,
    exportable: exportable,
    getCsvValue: getCsvValue,
    csvTitle: csvTitle,
    isLoading: isLoading,
    isError: isError
  };
};

var flattenColumns = function flattenColumns(columns, responsive, parent) {
  var _context;

  return (0, _flat["default"])(_context = (0, _map["default"])(columns).call(columns, function (column) {
    var _context2;

    /* istanbul ignore else */
    if (!column.children) {
      var compatibleColumn = makeCompatibleColumn(column, responsive);
      return _objectSpread(_objectSpread({}, compatibleColumn), {}, {
        parents: (0, _toConsumableArray2["default"])(parent || [])
      });
    }

    return flattenColumns(column.children, responsive, (0, _concat["default"])(_context2 = []).call(_context2, (0, _toConsumableArray2["default"])(parent || []), [column.title]));
  })).call(_context, 3);
};

exports.flattenColumns = flattenColumns;

var extractColumns = function extractColumns(columns, parent) {
  var _context3;

  /* istanbul ignore next */
  // This function is used in drag and drop and we are not testing that
  // Because drag/drop things cannot be tested in env like jsdom without
  // actual layout rendering
  return (0, _flat["default"])(_context3 = (0, _map["default"])(columns).call(columns, function (column) {
    var _context4;

    if (!column.children) {
      return _objectSpread(_objectSpread({}, column), {}, {
        parents: (0, _toConsumableArray2["default"])(parent || [])
      });
    }

    return extractColumns(column.children, (0, _concat["default"])(_context4 = []).call(_context4, (0, _toConsumableArray2["default"])(parent || []), [column.title]));
  })).call(_context3, 3);
};

exports.extractColumns = extractColumns;

var rebuildColumnHirarchy = function rebuildColumnHirarchy(columns, colParents, column) {
  var leaf;

  function makeEmptyChildren(defs, parents) {
    var idx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var title = parents[idx];
    var existing = (0, _find["default"])(defs).call(defs, function (elem) {
      return elem.title === title;
    });
    /* istanbul ignore else */

    if (idx === parents.length) {
      leaf = defs;
      return;
    }

    if (!existing) {
      defs.push({
        title: title,
        key: title,
        children: []
      });
      makeEmptyChildren(defs[defs.length - 1].children, parents, idx + 1);
    } else {
      makeEmptyChildren(existing.children, parents, idx + 1);
    }
  }

  makeEmptyChildren(columns, colParents);
  leaf.push(column);
};

var rebuildColumnsDef = function rebuildColumnsDef(columns) {
  var columnsDef = [];
  (0, _forEach["default"])(columns).call(columns, function (column) {
    /* istanbul ignore else */
    // The else condition never hits but may act weirdly sometimes
    if (column.parents) {
      rebuildColumnHirarchy(columnsDef, column.parents, column);
    } else {
      columnsDef.push(column);
    }
  });
  return columnsDef;
};

exports.rebuildColumnsDef = rebuildColumnsDef;

var getMaxHeaderCount = function getMaxHeaderCount(columns) {
  var max = 1;
  (0, _forEach["default"])(columns).call(columns, function (_ref3) {
    var parents = _ref3.parents;

    if (parents && parents.length + 1 > max) {
      max = parents.length + 1;
    }
  });
  return max;
};

exports.getMaxHeaderCount = getMaxHeaderCount;

var buildHeaderRow = function buildHeaderRow(cells) {
  var result = [];

  for (var i = 0; i < cells.length; i++) {
    var _cells$i = cells[i],
        title = _cells$i.title,
        width = _cells$i.width;

    if (i === 0) {
      result.push({
        title: title,
        width: width
      });
    } else {
      var lastResultItem = result[result.length - 1];

      if (lastResultItem.title === title) {
        lastResultItem.width += width;
      } else {
        result.push({
          title: title,
          width: width
        });
      }
    }
  }

  return result;
};
/* istanbul ignore next */


exports.buildHeaderRow = buildHeaderRow;

var shuffleDndItems = function shuffleDndItems(columns, active, over) {
  var oldIndex = findIndexByKey(columns, active.id);
  var newIndex = findIndexByKey(columns, over.id);
  return (0, _sortable.arrayMove)(columns, oldIndex, newIndex);
};

exports.shuffleDndItems = shuffleDndItems;

var isFunction = function isFunction(func) {
  return typeof func === "function";
};

exports.isFunction = isFunction;

var isString = function isString(str) {
  return typeof str === "string";
};

exports.isString = isString;

var isObject = function isObject(obj) {
  return (0, _typeof2["default"])(obj) === "object" && obj !== null;
};

exports.isObject = isObject;

var getSelectionColumn = function getSelectionColumn(Component, multiSelect, fixed) {
  return {
    title: multiSelect ? "__checkbox_selection__" : "",
    width: 40,
    align: "center",
    flexShrink: 0,
    frozen: fixed ? _reactBaseTable.Column.FrozenDirection.LEFT : false,
    key: "__selection__",
    cellRenderer: function cellRenderer(props) {
      return /*#__PURE__*/_react["default"].createElement(Component, props);
    },
    parents: []
  };
};

exports.getSelectionColumn = getSelectionColumn;

var getTooltipPropsFromCallback = function getTooltipPropsFromCallback(cbResult) {
  /* istanbul ignore else */
  if (isString(cbResult) || isFunction(cbResult)) {
    return {
      text: cbResult
    };
  }
  /* istanbul ignore else */


  if (typeof cbResult === "number") {
    return {
      text: String(cbResult)
    };
  }
  /* istanbul ignore else */


  if (isObject(cbResult)) {
    return cbResult;
  }
  /* istanbul ignore next */
  // Probably we never run into null condition so ignoring it.
  // Tooltip will itself break in that case so no need to test it.


  return null;
};

exports.getTooltipPropsFromCallback = getTooltipPropsFromCallback;

var setColumnsInitialWidth = function setColumnsInitialWidth(cols, width, isSelectable) {
  var _context5, _context6;

  var effectiveWidth = isSelectable ? width - 50 : width;
  var totalFlex = (0, _reduce["default"])(_context5 = (0, _map["default"])(_context6 = (0, _filter["default"])(cols).call(cols, function (c) {
    return !c.hidden;
  })).call(_context6, function (c) {
    return c.flexGrow || 1;
  })).call(_context5, function (curr, total) {
    return curr + total;
  }, 0);
  return (0, _map["default"])(cols).call(cols, function (c) {
    var newCol = _objectSpread({}, c);

    newCol.width = effectiveWidth / totalFlex * (c.flexGrow || 1);
    return newCol;
  });
};

exports.setColumnsInitialWidth = setColumnsInitialWidth;

var getStoredColumnsDiff = function getStoredColumnsDiff(tableId, columns) {
  var configKey = "dg-conf-".concat(tableId);
  var diffExists = false;

  try {
    var configJson = localStorage.getItem(configKey);

    if (configJson) {
      var config = JSON.parse(configJson);
      diffExists = (0, _filter["default"])(columns).call(columns, function (column) {
        var storedCol = config[column.key];

        if (!storedCol || storedCol && (storedCol.hidden !== column.hidden || storedCol.frozen !== column.frozen || storedCol.width !== column.width)) {
          return true;
        }

        return false;
      }).length > 0;
    }

    return true;
  } catch (e) {
    diffExists = true;
  }

  return diffExists;
};

var storeTableConfigInLocalStorage = function storeTableConfigInLocalStorage(tableId, enablePersistConfig, columns) {
  if (tableId && enablePersistConfig && getStoredColumnsDiff(tableId, columns)) {
    var columnsObj = (0, _reduce["default"])(columns).call(columns, function (acc, curr) {
      acc[curr.key] = {
        width: curr.width,
        hidden: curr.hidden,
        frozen: curr.frozen
      };
      return acc;
    }, {});
    (0, _setTimeout2["default"])(function () {
      localStorage.setItem("dg-conf-".concat(tableId), (0, _stringify["default"])(columnsObj));
    }, 0);
  }
};

exports.storeTableConfigInLocalStorage = storeTableConfigInLocalStorage;

var hydradeColumnsFromLocalStorage = function hydradeColumnsFromLocalStorage(columns, tableId, enablePersistConfig) {
  if (!enablePersistConfig || !tableId) {
    return columns;
  }

  var storageKey = "dg-conf-".concat(tableId);

  try {
    var storedJson = localStorage.getItem(storageKey);

    if (storedJson) {
      var storedCols = JSON.parse(storedJson);
      var storedColKeys = (0, _keys["default"])(storedCols);
      var originalColKeys = (0, _map["default"])(columns).call(columns, function (_ref4) {
        var key = _ref4.key;
        return key;
      });

      if (storedColKeys.length !== originalColKeys.length || storedColKeys.length === originalColKeys.length && !(0, _every["default"])(storedColKeys).call(storedColKeys, function (s) {
        return (0, _includes["default"])(originalColKeys).call(originalColKeys, s);
      })) {
        localStorage.removeItem(storageKey);
        return columns;
      }

      return (0, _map["default"])(storedColKeys).call(storedColKeys, function (sck) {
        var storedCol = storedCols[sck];
        var correspondingCol = (0, _find["default"])(columns).call(columns, function (c) {
          return c.key === sck;
        });
        return _objectSpread(_objectSpread({}, correspondingCol), {}, {
          width: storedCol.width,
          hidden: storedCol.hidden,
          frozen: storedCol.frozen
        });
      });
    }

    return columns;
  } catch (error) {
    return columns;
  }
};

exports.hydradeColumnsFromLocalStorage = hydradeColumnsFromLocalStorage;

var shouldReallySetInitialWidth = function shouldReallySetInitialWidth(columns, tableId, enablePersistConfig) {
  if (!enablePersistConfig || !tableId) {
    return true;
  }

  var storageKey = "dg-conf-".concat(tableId);

  try {
    var storedJson = localStorage.getItem(storageKey);

    if (storedJson) {
      var storedCols = JSON.parse(storedJson);
      var storedColKeys = (0, _keys["default"])(storedCols);
      var originalColKeys = (0, _map["default"])(columns).call(columns, function (_ref5) {
        var key = _ref5.key;
        return key;
      });

      if (storedColKeys.length !== originalColKeys.length || storedColKeys.length === originalColKeys.length && !(0, _every["default"])(storedColKeys).call(storedColKeys, function (s) {
        return (0, _includes["default"])(storedColKeys).call(storedColKeys, s);
      })) {
        return true;
      }

      return false;
    }

    return true;
  } catch (error) {
    return true;
  }
};

exports.shouldReallySetInitialWidth = shouldReallySetInitialWidth;